export default __webpack_public_path__ + "static/media/cathode-pic2.75f673dd.jpg";